import React from "react";
import { Accordion } from "react-bootstrap";
import TabSingleAccordion from "./TabSingleAccordion";
const TabAccordion = ({ data }) => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        {data &&
          data.map((val, index) => {
            return <TabSingleAccordion val={val} key={index} eventKey={index} question={val.question} answer={val.answer} />;
          })}
      </Accordion>
    </>
  );
};

export default TabAccordion;
